import React from 'react';

import * as api from '../api';
import { type ErrorMessage } from '../models';

import { OtpForm, type OtpFormProps } from './utilities';

/** Displays the TOTP form and handles backend verification */
export default function TotpForm({
  onSuccess: handleSuccess,
  onFailure: handleFailure,
  isCodeReadyForSubmission,
  onSubmittableChange: handleSubmittableChange,
}: OtpFormProps): JSX.Element {
  return (
    <OtpForm
      isCodeReadyForSubmission={isCodeReadyForSubmission}
      onVerify={handleVerify}
      onSuccess={handleSuccess}
      onFailure={handleFailure}
      onSubmittableChange={handleSubmittableChange}
    />
  );
}

async function handleVerify(code: string): Promise<boolean | ErrorMessage> {
  return api.validateTotpCode(code);
}
